import { uploadSegmentFormFields } from '@openx/types/segments.ts';
import type { I18nTranslate } from '@openx/types/translations.ts';
import { mixed, object, string } from 'yup';

import { supportedFileTypes } from './constants.ts';

export const getValidationSchema = (t: I18nTranslate) =>
  object().shape({
    [uploadSegmentFormFields.NAME]: string().required(t('Segment name is required')),
    [uploadSegmentFormFields.DATA_TYPE]: string().nullable().required(t('Data type is required')),
    [uploadSegmentFormFields.FILE]: mixed<File>()
      .required(t('File is required'))
      .test(
        'fileSize',
        t('File cannot be empty'),
        (file: File | undefined) => !!file && file.size !== undefined && file.size > 0
      )
      .test(
        'fileFormat',
        t('Wrong file type, only .csv or .txt files are supported'),
        (file: File | undefined) => !!file && file.type !== undefined && supportedFileTypes.includes(file.type)
      ),
  });
